// Angular
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

// RxJS
import { Observable } from 'rxjs';

// Third-party
import { environment } from '@environment';

// Local
import { EmulatableUser, EmulatedProfile } from '@app/model/emulation.model';
import { emulationEndpoints } from '@app/types/api/endpoints/emulation.endpoints';

/**
 * Base url for the api.
 */
const BASE_URL = environment.ApiServer.BaseURL;

/**
 * Emulation endpoints for the api.
 */
const EMULATION_ENDPOINTS = emulationEndpoints(BASE_URL);

/**
 * HTTP access to the admin user-emulation endpoints.
 */
@Injectable({ providedIn: 'root' })
export class EmulationApiService {
  private readonly http = inject(HttpClient);

  /**
   * Whether the current user has any capability to emulate other users.
   */
  getEnabled(): Observable<boolean> {
    return this.http.get<boolean>(EMULATION_ENDPOINTS.getEnabled());
  }

  /**
   * Search the users the current user is permitted to emulate.
   * @param search Term matched against name, email or login (min 2 chars server-side).
   */
  searchUsers(search: string): Observable<EmulatableUser[]> {
    return this.http.get<EmulatableUser[]>(EMULATION_ENDPOINTS.searchUsers(search));
  }

  /**
   * Get the effective identity profile of the target to emulate.
   * @param userId The target user's unique id.
   */
  getProfile(userId: string): Observable<EmulatedProfile> {
    return this.http.get<EmulatedProfile>(EMULATION_ENDPOINTS.getProfile(userId));
  }
}
